import { useApi } from '@/api';
import { ChartSkeleton } from '@/components';
import { useChartTooltip } from '@/hooks';
import {
  DoughnutChart,
  Flex,
  formatPercentage,
  textShortener
} from '@blockanalitica/ui';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HoldersArbitrumDonutChart({ address }) {
  const [data, error] = useApi({
    url: `/tokens/arbitrum/${address}/share/`
  });

  if (error) {
    throw error;
  }
  const navigate = useNavigate();
  const customTooltip = useChartTooltip(
    data,
    'wallet_address',
    'percent_of_total',
    true,
    'balance'
  );

  const chartData = useMemo(() => {
    if (data) {
      return {
        labels: data.map((row) => textShortener(row.wallet_address)),
        datasets: [
          {
            data: data.map((row) => row.percent_of_total),
            hoverOffset: 30
          }
        ]
      };
    }
    return null;
  }, [data]);

  const mapping = useMemo(() => {
    if (data) {
      return data.reduce((acc, row) => {
        let key = textShortener(row.wallet_address);
        acc[key] =
          key === 'others' ? 'holders' : `holders/${row.wallet_address}`;
        return acc;
      }, {});
    }
    return {};
  }, [data]);

  const customConfig = useMemo(
    () => ({
      options: {
        aspectRatio: 1.8,
        layout: {
          padding: 10
        },
        plugins: {
          legend: {
            position: 'bottom'
          },
          tooltip: {
            enabled: false,
            position: 'nearest',
            external: customTooltip
          }
        }
      }
    }),
    [customTooltip]
  );

  if (data) {
    return (
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        paddingTop="m"
        width="100%">
        <DoughnutChart
          // @ts-ignore
          config={customConfig}
          data={chartData}
          valueFormatter={formatPercentage}
          url={`/tokens/arbitrum/${address}`}
          mapping={mapping}
          navigate={navigate}
        />
      </Flex>
    );
  }

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      paddingTop="m"
      width="100%">
      <ChartSkeleton type="doughnut" />
    </Flex>
  );
}
